import React, { useState } from 'react';
import './Biomarkers.css';
// eslint-disable-next-line import/no-cycle
import app from 'new-ui/app';
import PropTypes from 'prop-types';
import { POPUP } from 'utils/constants/popup';
import Button from 'new-ui/Components/Button';
import { THEMES } from 'new-ui/constants';
import { useTranslation } from 'utils/modifiedTranslation';
import { CLIENT_IM_NOT_SURE } from 'new-ui/Components/Intake/Intake';
import { BulletButton } from '../SingleOptionSelect';

const Biomarkers = (props) => {
  const {
    user,
    onselect,
    shouldAddNotSureOption = true,
  } = props;
  const [biomarkers, setBiomarkers] = useState(user?.condition_profile?.biomarkers ?? []);
  const { t } = useTranslation();

  const isNoneSelected = () => biomarkers?.length === 1 && biomarkers[0] === 'none';

  const handleAnswerManually = () => {
    app.openPopup(POPUP.BIOMARKERS, {
      biomarkers,
      onSelect: (newBiomarkers) => {
        const nextBiomarkers = [...newBiomarkers];
        onselect(nextBiomarkers);
        setBiomarkers(newBiomarkers);
      },
    }, true);
  };

  return (
    <div className="biomarkers-question">
      <div className="biomarkers-question-actions">
        <Button
          action={handleAnswerManually}
          title="Select Biomarkers"
          theme={THEMES.ORANGE}
          style={{
            maxWidth: 'max-content',
            height: 'unset',
            alignSelf: 'stretch',
          }}
        />
      </div>
      {
        biomarkers.length ? null : (
          <div className="multi-pages-submenu margin-top-10">
            <BulletButton
              label={t('questionnaire.biomarkers.skip')}
              isSelected={isNoneSelected()}
              action={() => onselect(['none'])}
            />
            {shouldAddNotSureOption ? (
              <BulletButton
                label={t('intake.im_not_sure')}
                action={() => onselect(CLIENT_IM_NOT_SURE)}
              />
            ) : null}
          </div>
        )
      }
    </div>
  );
};

Biomarkers.propTypes = {
  user: PropTypes.object.isRequired,
  onselect: PropTypes.func.isRequired,
  shouldAddNotSureOption: PropTypes.bool,
};

export default Biomarkers;
